// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"5c3df5f2","878":"f51e9e8f"}[chunkId] + ".chunk.js";
};